import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { SaveAgreementDTO } from "../../models/agreement.model";
import { AgreementRepository } from "../../repositories/agreement.repository";

interface SaveAgreementUseCaseType {
  agreementId: number;
  smarts: SaveAgreementDTO[];
}
export class SaveAgreementUseCase
  implements UseCase<SaveAgreementUseCaseType, boolean>
{
  constructor(private repo: AgreementRepository) {}
  execute(param: SaveAgreementUseCaseType): Observable<boolean> {
    return this.repo.save(param.smarts);
  }
}

const saveAgreementUseCaseFactory = (repo: AgreementRepository) =>
  new SaveAgreementUseCase(repo);

export const saveAgreementUseCaseProvider: Provider = {
  provide: SaveAgreementUseCase,
  useFactory: saveAgreementUseCaseFactory,
  deps: [AgreementRepository],
};
